import { Button, Card, Form, Input, Select, Space } from "antd";
import { useEffect, useState } from "react";
import { CHANNEL, COMMUNICATE_MODULE, INTENTION } from "@zhihaoscm/meta";
import { customerService } from "@/api/services/customerService";
import UserLabel from "./userLabel";

/** 用户沟通画像编辑表单，复用 customerService.updateCustomerInfo 字段契约。 */
export default function UserInfoForm({
    info,
    userId,
    onCancel,
    onSaved
}: {
    info?: Record<string, any>;
    userId?: number;
    onCancel?: () => void;
    onSaved?: () => void;
}) {
    const [form] = Form.useForm();
    const [saving, setSaving] = useState(false);
    useEffect(() => {
        form.setFieldsValue({ ...info, userLabel: info?.userLabel || [] });
    }, [info, form]);
    const submit = async (values: any) => {
        if (!userId) return;
        setSaving(true);
        try {
            await customerService.updateCustomerInfo(userId, values);
            onSaved?.();
        } finally {
            setSaving(false);
        }
    };
    return (
        <Card title="编辑用户信息">
            <Form form={form} layout="vertical" onFinish={values => void submit(values)}>
                <div className="grid grid-cols-2 gap-x-5">
                    <Form.Item name="name" label="姓名">
                        <Input maxLength={15} />
                    </Form.Item>
                    <Form.Item name="provinceName" label="区域">
                        <Input placeholder="请输入区域" />
                    </Form.Item>
                    <Form.Item name="channel" label="了解渠道">
                        <Select options={CHANNEL.options} />
                    </Form.Item>
                    <Form.Item name="intention" label="意向度">
                        <Select options={INTENTION.options} />
                    </Form.Item>
                    <Form.Item name="sandFlag" label="是否为砂石行业">
                        <Select
                            options={[
                                { value: 1, label: "是" },
                                { value: 0, label: "否" }
                            ]}
                        />
                    </Form.Item>
                    <Form.Item name="industry" label="行业">
                        <Input maxLength={15} />
                    </Form.Item>
                    <Form.Item name="settlePlatformFlag" label="是否需要入驻平台">
                        <Select
                            options={[
                                { value: 1, label: "是" },
                                { value: 0, label: "否" }
                            ]}
                        />
                    </Form.Item>
                    <Form.Item name="concernModule" label="关注模块">
                        <Select mode="multiple" options={COMMUNICATE_MODULE.options} />
                    </Form.Item>
                </div>
                <Form.Item name="userLabel" label="用户标签">
                    <UserLabel info={info?.userLabel} onChange={value => form.setFieldValue("userLabel", value)} />
                </Form.Item>
                <Space>
                    <Button type="primary" htmlType="submit" loading={saving}>
                        保存
                    </Button>
                    <Button onClick={onCancel}>取消</Button>
                </Space>
            </Form>
        </Card>
    );
}
